import { type TTemplateDto } from '@/types/templates';

import { ApiConnector } from '../api.connector';

class ReportsApi extends ApiConnector {
  getTemplates() {
    return this.call({ path: 'utils/templates' });
  }

  createTemplate(data: TTemplateDto) {
    return this.call({
      path: `utils/templates/create`,
      body: data,
      method: 'post'
    });
  }

  redactTemplate(data: { templateId: string; template: TTemplateDto }) {
    return this.call({
      path: `utils/templates/${data.templateId}/updateTemplate`,
      body: data.template,
      method: 'patch'
    });
  }
}

export const reportsApi = new ReportsApi();
